import React from "react";
import { Box, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "../FormFields";

type SearchBarProps = {
  value: string;
  onChange: (v: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  hidden?: boolean;
};

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onSubmit, inputRef, hidden }) => {
  if (hidden) return null;

  return (
    <Box component="form" onSubmit={onSubmit} sx={{ mx: 2, width: 420 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Search by title…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        inputRef={inputRef}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.secondary' }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchBar;


